import { type ReactElement } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import { SHIFT_FEEDBACK_RESOLVER_PATH } from "./constants";
import { ShiftFeedbackResolver } from "./ShiftFeedbackResolver";

/**
 * Routes for ShiftFeedback module
 * Used for resolving dynamic links to QR code feedback
 */
export function ShiftFeedbackRoutes(): ReactElement {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/${SHIFT_FEEDBACK_RESOLVER_PATH}`}>
        <ShiftFeedbackResolver />
      </Route>
    </Switch>
  );
}
